// 共通系
import accountRepository from "./entity/common/accountRepository";
import notificationRepository from "./entity/common/notificationRepository";
import pictureRepository from "./entity/common/pictureRepository";
import vesselRepository from "./entity/common/vesselRepository";
import plotRepository from "./entity/common/plotRepository";
import enterprisePublicRepository from "./entity/common/enterprisePublicRepository";
import userPublicRepository from "./entity/common/userPublicRepository";
import constantRepository from "./entity/common/constantRepository";
import voyageHistoryRepository from "./entity/common/voyageHistoryRepository";
import voyageRecordsRepository from "./entity/common/voyageRecordsRepository";
import voyageRepository from "./entity/common/voyageRepository";
import polarisRepository from "./entity/common/polarisRepository";

// 法人向けAPI系
import enterpriseRepository from "./entity/enterprise/enterpriseRepository";
import enterpriseUserRepository from "./entity/enterprise/enterpriseUserRepository";
import enterpriseVesselRepository from "./entity/enterprise/enterpriseVesselRepository";
import enterpriseCameraRepository from "./entity/enterprise/enterpriseCameraRepository";
import enterpriseVesselDocumentRepository from "./entity/enterprise/enterpriseVesselDocumentRepository";
import enterpriseVesselPictureRepository from "./entity/enterprise/enterpriseVesselPictureRepository";
import enterprisePlotRepository from "./entity/enterprise/enterprisePlotRepository";
import enterpriseLicenseRepository from "./entity/enterprise/enterpriseLicenseRepository";
import enterpriseLicensePictureRepository from "./entity/enterprise/enterpriseLicensePictureRepository";
import enterpriseVoyageHistoriesRepository from "./entity/enterprise/enterpriseVoyageHistoriesRepository";
import enterpriseVesselDisplayChannelRepository from "./entity/enterprise/enterpriseVesselDisplayChannelRepository";
import enterpriseAdminAddonRepository from "./entity/enterprise/enterpriseAdminAddonController";

// 機能拡張API
import portMasterVesselMasterRepository from "./entity/addon/port-master/portMasterVesselMasterRepository";
import portMasterBerthMasterRepository from "./entity/addon/port-master/portMasterBerthMasterRepository";
import portMasterEnterpriseAgencyMasterRepository from "./entity/addon/port-master/portMasterEnterpriseAgencyMasterRepository";
import portMasterAgencyMasterRepository from "./entity/addon/port-master/portMasterAgencyMasterRepository";
import portMasterPilotMasterRepository from "./entity/addon/port-master/portMasterPilotMasterRepository";
import portMasterTugBoatMasterRepository from "./entity/addon/port-master/portMasterTugBoatMasterRepository";
import portMasterVehicleMasterRepository from "./entity/addon/port-master/portMasterVehicleMasterRepository";
import portMasterRopePickingBoatMasterRepository from "./entity/addon/port-master/portMasterRopePickingBoatMasterRepository";
import portMasterTeamLeaderMasterRepository from "./entity/addon/port-master/portMasterTeamLeaderMasterRepository";
import portMasterTagMasterRepository from "./entity/addon/port-master/portMasterTagMasterRepository";
import portMasterPortSelectRepository from "./entity/addon/port-master/portMasterPortSelectRepository";
import portMasterPortColorRepository from "./entity/addon/port-master/portMasterPortColorRepository";
import portMasterPortWharfRepository from "./entity/addon/port-master/portMasterPortWharfRepository";
import portMasterTasksRepository from "./entity/addon/port-master/portMasterTasksRepository";
import portMasterDailyReportsRepository from "./entity/addon/port-master/portMasterDailyReportsRepository";
import gkmgPortMasterTasksRepository from "./entity/addon/gkmg/gkmgPortMasterTasksRepository";
import gkmgPortMasterDailyReportsRepository from "./entity/addon/gkmg/gkmgPortMasterDailyReportsRepository";

// Secure Dataflow
import enterpriseVesselSecureDataflowChannelRepository from "./entity/addon/secure-dataflow/enterpriseVesselSecureDataflowChannelRepository";

// 作業船位置決め管理
import gkmgAnchorRepository from "./entity/addon/gkmg/gkmgAnchorRepository";

// レーダグリッド
import radarGridRiskAssessmentsRepository from "./entity/addon/radar-grid/radarGridRiskAssessmentsRepository";
import radarGridObjectsRepository from "./entity/addon/radar-grid/radarGridObjectsRepository";

// 履歴API系
import enterpriseVoyageRecordsRepository from "@/api/aisea/entity/enterprise/enterpriseVoyageRecordsRepository";

const repositories = {
  // 共通系
  account: accountRepository,
  notification: notificationRepository,
  picture: pictureRepository,
  plot: plotRepository,
  enterprisePublic: enterprisePublicRepository,
  userPublic: userPublicRepository,
  constant: constantRepository,
  vessel: vesselRepository,
  voyageHistory: voyageHistoryRepository,
  voyageRecords: voyageRecordsRepository,
  voyage: voyageRepository,
  polaris: polarisRepository,

  // 法人向けAPI系
  enterprise: enterpriseRepository,
  enterpriseUser: enterpriseUserRepository,
  enterpriseVessel: enterpriseVesselRepository,
  enterpriseCamera: enterpriseCameraRepository,
  enterpriseVesselDocument: enterpriseVesselDocumentRepository,
  enterpriseVesselPicture: enterpriseVesselPictureRepository,
  enterprisePlot: enterprisePlotRepository,
  enterpriseLicense: enterpriseLicenseRepository,
  enterpriseLicensePicture: enterpriseLicensePictureRepository,
  enterpriseVoyageHistories: enterpriseVoyageHistoriesRepository,
  enterpriseVesselDisplayChannel: enterpriseVesselDisplayChannelRepository,
  enterpriseAdminAddon: enterpriseAdminAddonRepository,
  enterpriseVoyageRecords: enterpriseVoyageRecordsRepository,

  portMasterVesselMaster: portMasterVesselMasterRepository,
  portMasterBerthMaster: portMasterBerthMasterRepository,
  portMasterEnterpriseAgencyMaster: portMasterEnterpriseAgencyMasterRepository,
  portMasterAgencyMaster: portMasterAgencyMasterRepository,
  portMasterPilotMaster: portMasterPilotMasterRepository,
  portMasterTugBoatMaster: portMasterTugBoatMasterRepository,
  portMasterVehicleMaster: portMasterVehicleMasterRepository,
  portMasterRopePickingBoatMaster: portMasterRopePickingBoatMasterRepository,
  portMasterTeamLeaderMaster: portMasterTeamLeaderMasterRepository,
  portMasterTagMaster: portMasterTagMasterRepository,
  portMasterPortSelect: portMasterPortSelectRepository,
  portMasterPortColor: portMasterPortColorRepository,
  portMasterPortWharf: portMasterPortWharfRepository,
  portMasterTasks: portMasterTasksRepository,
  portMasterDailyReports: portMasterDailyReportsRepository,
  gkmgPortMasterTasks: gkmgPortMasterTasksRepository,
  gkmgPortMasterDailyReports: gkmgPortMasterDailyReportsRepository,

  // Secure Dataflow
  enterpriseVesselSecureDataflowChannel:
    enterpriseVesselSecureDataflowChannelRepository,

  // 作業船位置決め管理
  gkmgAnchor: gkmgAnchorRepository,

  // レーダグリッド
  radarGridRiskAssessments: radarGridRiskAssessmentsRepository,
  radarGridObjects: radarGridObjectsRepository,
};

export const AiseaApiFactory = {
  get: (name) => repositories[name],
};
